// @flow

import { observer } from "mobx-react";
import React from "react";

import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";
import VideoEditorStore from "app/stores/VideoEditorStore";

import VideoProgress from "app/components/VideoProgress/VideoProgress";

type Props = {
    hide?: boolean
};

@observer
export default class VideoProgressContainer extends React.Component<Props> {
    render() {
        return (
            <VideoProgress
                duration={VideoStore.video.duration}
                progress={VideoPlayerStore.progress}
                buffered={VideoPlayerStore.bufferedProgress}
                onSeek={VideoPlayerStore.seekTo}
                times={true}
                pointer={true}
                hide={this.props.hide}
                hoverProgress={VideoEditorStore.hoverProgress}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoProgressContainer.js